var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Assets"},[_c('HeaderReturn',{attrs:{"title":"通证管理记录"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('ul',[_c('li',[_c('div',[_vm._v("通证管理")]),_c('div',[_c('p',[_vm._v("状态")]),_c('p',[_vm._v("时间")])]),_c('div',[_vm._v("\n                    操作\n                ")])])])])
}]

export { render, staticRenderFns }